import { george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { STYLE_CENTERED_CARD } from "components/util/primitives";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { IConsentAccount } from "types/usermanagement";
import { formatIban } from "util/helpers";
import { TPP } from "./TPP";
import { TPPDetailsConfirmationDialog } from "./TPPDetailsConfirmationDialog";
import { TPPRoutes } from "./TPPRoutes";
import { TPPStore } from "./TPPStore";

type IProps = RouteComponentProps<{}> & {
    store: TPPStore
};

const AccountList = ({
    title,
    accounts
}: {
    title: string;
    accounts: IConsentAccount[];
}) => {
    if (accounts.length === 0) {
        return null;
    }

    const entries = accounts.map((account, index) => (
        <div key={`${title}_${account.iban}`}>
            {account.iban && (
                <pr.P_14_CONTENT>
                    {ui.__("account.iban")} {formatIban(account.iban)}
                </pr.P_14_CONTENT>
            )}
            {account.bic && (
                <pr.P_14_CONTENT>
                    {ui.__("common.bic")} {account.bic}
                </pr.P_14_CONTENT>
            )}
            {account.currency && (
                <pr.P_14_CONTENT>
                    {ui.__("common.currency")} {account.currency}
                </pr.P_14_CONTENT>
            )}
            {index < accounts.length - 1 && <pr.LightSeparatorLine spacing={8} />}
        </div>
    ));

    return (
        <div style={{ paddingTop: 16, paddingBottom: 16 }}>
            <george.SectionTitle style={{ marginTop: 0, fontWeight: 600 }}>{title}</george.SectionTitle>
            {entries}
        </div>
    );
};

export const TPPDetails = observer(({ store }: IProps) => {
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);

    const handleRevokeAccess = () => {
        setConfirmationOpen(true);
    };

    const consent = store.currentConsent;

    if (!consent) {
        return null;
    }

    const explicitConsent = consent.consents.length > 0 ? consent.consents[0] : null;

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;
    const contentPadding = ui.windowWidth < 800 ? 24 : 32;

    return (
        <>
            <george.Background>
                <PageComponent>
                    <george.Card
                        disableTopSpacing
                        style={{
                            borderRadius: 8,
                            boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)",
                            ...STYLE_CENTERED_CARD
                        }}
                    >
                        <div style={{ padding: contentPadding }}>
                            <TPP consent={consent} />
                            {explicitConsent && (
                                <>
                                    <AccountList title={ui.__("tpp.accounts")} accounts={explicitConsent.access.accounts} />
                                    <pr.LightSeparatorLine />
                                    <AccountList title={ui.__("tpp.balances")} accounts={explicitConsent.access.balances} />
                                    <pr.LightSeparatorLine />
                                    <AccountList title={ui.__("tpp.transactions")} accounts={explicitConsent.access.transactions} />
                                </>
                            )}
                        </div>
                        {!externalInterfaceStore.isGeorgeApp &&
                            <pr.LightSeparatorLine style={{ marginBottom: theme.MARGIN }} />
                        }
                        <george.ActionButton
                            messageId="tpp.button.revoke"
                            onClick={handleRevokeAccess}
                            {...george.getActionButtonWebVersionProps()}
                        />
                    </george.Card>
                </PageComponent>
            </george.Background>
            <TPPDetailsConfirmationDialog
                store={store}
                show={confirmationOpen}
                onClose={async (revoke?: boolean) => {
                    setConfirmationOpen(false);
                    if (revoke) {
                        try {
                            await store.revokeConsent(consent.id);
                            pushRoute(TPPRoutes.ROOT);
                        } catch (err) {
                            pushRoute("/error");
                        }
                    }
                }}
            />
        </>
    );
});



// WEBPACK FOOTER //
// ./src/components/tpp/TPPDetails.tsx